import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { I18nextProvider } from "react-i18next";
import { AuthProvider } from "react-oidc-context";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { oidcConfig } from "./config";
import i18n from "./i18n/i18n";
import AppRouter from "./routes";

// LicenseInfo.setLicenseKey(String(config.licenseMui));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  return (
    <AuthProvider {...oidcConfig}>
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <I18nextProvider i18n={i18n}>
            <AppRouter />
            <ToastContainer />
          </I18nextProvider>
        </LocalizationProvider>
      </QueryClientProvider>
    </AuthProvider>
  );
};

export default App;
